/**
 * @prettier
 * @flow
 */
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

export function UpdatingContentProgress({ loading, top, bottom }: Props) {
    const classes = useStyles();

    if (loading === false) return null;
    return (
        <LinearProgress
            className={classes.linearProgress}
            style={{
                top: top ? 0 : undefined,
                bottom: bottom ? 0 : undefined,
            }}
        />
    );
}

const useStyles = makeStyles(theme => ({
    linearProgress: {
        position: 'absolute',
        width: '100%',
    },
}));

type Props = {|
    loading?: boolean,
    top?: boolean,
    bottom?: boolean,
|};
